import React, {useEffect, useState} from 'react'
// Styles
import './alert.style.css'
// Actions
import { Base_API } from '../../_actions/matcher'
// Prop Types
import PropTypes from 'prop-types'; // ES6

function Alert({ alertStatus, title, desc, endpoint, btnText, setAlertStatus }) {
    const [startAnimate, setStartAnimate] = useState(false);

    useEffect(() => {
        // animate
        if(alertStatus === true)
        {
            // transition
            setTimeout(() => {
                setStartAnimate(true);
            }, 50)
        }else
        {
            setStartAnimate(false);
        }
    }, [alertStatus]);

    useEffect(() => {
        if(startAnimate === false)
        {
            // transition
            setTimeout(() => {
                setAlertStatus(false);
            }, 50)
        }
    }, [startAnimate])

    // Handle Submit
    const handleSubmit = () => {
        if(endpoint !== '')
        {
            window.location.href = endpoint
            setAlertStatus(false);
        }else
        {
            setAlertStatus(false);
        }
    }

    return (
        <div className={`alert-container ${alertStatus ? 'active' : null}`}>
            <div className={`card ${startAnimate ? 'active' : null}`}>
                {/* title */}
                <h1 className="title">{title}</h1>
                {/* description */}
                <p className="desc">{desc}</p>
                {/* endpoint */}
                <button 
                    className="endpoint"
                    onClick={handleSubmit}
                >
                    {btnText}
                </button>
            </div>
        </div>
    )
}

export default Alert

Alert.propTypes = {
    alertStatus: PropTypes.bool,
    title: PropTypes.string,
    desc: PropTypes.string,
    endpoint: PropTypes.string, // destination
    btnText: PropTypes.string,
    setAlertStatus: PropTypes.func, // func close alert
}